// extracted by mini-css-extract-plugin
module.exports = {"Spineer":"Spinner_Spineer__km3SJ","lds-ripple":"Spinner_lds-ripple__258iN"};